import { TEMPLATE_API_URL, TEMPLATE_FILTER_URL, TEMPLATE_SEARCH_BY_DEALER_ID_AND_TYPES_URL } from 'constants/ApiConstants';
import type { ApiError, MetaAction, PageContent } from 'modules/global/generic.types';

import { TemplateTypeEnum } from 'modules/global/typing/enums/templates.enum';

import * as types from './actionTypes';
import type * as actions from './types/actions';
import type { Template } from './types/entities';

export const fetchTemplatesFOByDealerRequest = (params: actions.FetchTemplatesFOByDealerParams, meta: MetaAction = {}): actions.FetchTemplatesFOByDealerRequestAction => ({
  type: types.FETCH_TEMPLATES_FO_BY_DEALER_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: TEMPLATE_SEARCH_BY_DEALER_ID_AND_TYPES_URL,
      params: {
        ...params,
        types: [TemplateTypeEnum.FO, TemplateTypeEnum.CUSTOM],
      },
    },
  },
  meta,
});

export const fetchTemplatesFOByDealerSuccess = (templates: PageContent<Template>, meta: MetaAction = {}): actions.FetchTemplatesFOByDealerSuccessAction => ({
  type: types.FETCH_TEMPLATES_FO_BY_DEALER_SUCCESS,
  payload: templates,
  meta,
});

export const fetchTemplatesFOByDealerFailure = (error: ApiError, meta: MetaAction = {}): actions.FetchTemplatesFOByDealerFailureAction => ({
  type: types.FETCH_TEMPLATES_FO_BY_DEALER_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const fetchGroupCustomTemplate = (params: actions.FetchGroupCustomTemplateParams, meta: MetaAction = {}): actions.FetchGroupCustomTemplateAction => ({
  type: types.FETCH_GROUP_CUSTOM_TEMPLATE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: TEMPLATE_FILTER_URL,
      params: { ...params, types: TemplateTypeEnum.CUSTOM, notExist: 'dealerId' },
    },
  },
  meta,
});

export const fetchGroupCustomTemplateSuccess = (templates: PageContent<Template>, meta: MetaAction = {}): actions.FetchGroupCustomTemplateSuccessAction => ({
  type: types.FETCH_GROUP_CUSTOM_TEMPLATE_SUCCESS,
  payload: templates,
  meta,
});

export const fetchGroupCustomTemplateFailure = (error: ApiError, meta: MetaAction = {}): actions.FetchGroupCustomTemplateFailureAction => ({
  type: types.FETCH_GROUP_CUSTOM_TEMPLATE_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const redirectToCustomTemplateLink = (templateId: string, params: actions.TemplateLinkQueryParams, meta: MetaAction = {}): actions.RedirectToCustomTemplateLinkAction => ({
  type: types.REDIRECT_TO_CUSTOM_TEMPLATE_LINK_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${TEMPLATE_API_URL}/${templateId}/link`,
      params,
    },
    templateId,
  },
  meta,
});

export const redirectToCustomTemplateLinkSuccess = (
  { templateId, link }: { templateId: string; link: string },
  meta: MetaAction = {}
): actions.RedirectToCustomTemplateLinkSuccessAction => ({
  type: types.REDIRECT_TO_CUSTOM_TEMPLATE_LINK_SUCCESS,
  payload: { link, templateId },
  meta,
});

export const redirectToCustomTemplateLinkFailure = (templateId: string, error: ApiError, meta: MetaAction = {}): actions.RedirectToCustomTemplateLinkFailureAction => ({
  type: types.REDIRECT_TO_CUSTOM_TEMPLATE_LINK_FAILURE,
  payload: { templateId, error },
  error: true,
  meta,
});

export const deleteTemplate = (templateId: string, meta: MetaAction = {}): actions.DeleteTemplateAction => ({
  type: types.DELETE_TEMPLATE,
  payload: {
    request: {
      method: 'DELETE',
      url: `${TEMPLATE_API_URL}/${templateId}`,
    },
    templateId,
  },
  meta,
});

export const deleteTemplateSuccess = (templateId: string, meta: MetaAction = {}): actions.DeleteTemplateSuccessAction => ({
  type: types.DELETE_TEMPLATE_SUCCESS,
  payload: templateId,
  meta,
});

export const deleteTemplateFailure = (error: ApiError, templateId: string, meta: MetaAction = {}): actions.DeleteTemplateFailureAction => ({
  type: types.DELETE_TEMPLATE_FAILURE,
  payload: { templateId, error },
  error: true,
  meta,
});
